import { atom } from "recoil";

export const productsState = atom({
    key: 'productsState',
    default: [],
});
